<template>
  <div class="box f_color1 font2">
    <van-nav-bar 
      :title="'数据概览'" 
      left-text="" 
      left-arrow
      @click-left="onClickLeft" 
      @click-right="onClickRight"
      :style="{ background: '#1a1a1a', color: '#ffffff' }"
      :title-style="{ color: '#ffffff' }"
      :left-arrow-style="{ color: '#ffffff' }"
    >
      <template #right>
        <div class="nav-bar-right">
          <template v-if="this.groupInfo && this.groupInfo.type === 0">
            <a ref="downloadLink" :href="downloadUrl" target="downloadFile"></a>
            <van-button type="primary" class="export-button" icon="download" plain @click="downloadFile">导出
            </van-button>
            <iframe style="display: none;" name="downloadFile"></iframe>
          </template>
        </div>
      </template>
    </van-nav-bar>
    <div v-if="!!groupInfo">
      <div class="search-section">
      <!-- 自定义搜索框（替换原来的 van-search） -->
<div class="custom-search">
  <!-- 输入框容器 -->
  <div class="search-input-wrap">
    <input 
      type="text" 
      v-model="search" 
      placeholder="输入用户ID"
      class="search-input"
      @keyup.enter="onSearch" 
    >
  </div>
  <!-- 搜索按钮 -->
  <div class="search-action-btn" @click="onSearch">
    搜索
  </div>
</div>
        <div class="search-filters">
          <div class="id-type">
            <van-radio-group v-model="checked" direction="horizontal">
              <van-radio name="0" icon-size="14px" class="font1">用户ID</van-radio>
              <van-radio name="1" icon-size="14px" class="font1">上级ID</van-radio>
            </van-radio-group>
          </div>
          <van-dropdown-menu v-if="this.groupInfo && this.groupInfo.type === 0" class="income-type"
                           active-color="#ff9500">
            <van-dropdown-item v-model="incomeType" :options="incomeTypes" @change="onIncomeTypeChanged"/>
          </van-dropdown-menu>
        </div>
        <div class="date-range">
          <div class="time ltime" @click="onTimeBeginTapped">
            <van-icon name="calendar" size="14" color="#666" />
            <span>&nbsp;&nbsp;{{ timeBeginDisplay }}&nbsp;&nbsp;</span>
          </div>
          <span>&nbsp;至&nbsp;</span>
          <div class="time" @click="onTimeEndTapped">
            <van-icon name="calendar" size="14" color="#666" />
            <span>&nbsp;&nbsp;{{ timeEndDisplay }}&nbsp;&nbsp;</span>
          </div>
        </div>
      </div>
      <van-list class="list font2" v-model:loading="loading" :immediate-check="false" :finished="finished"
                finished-text="没有更多了" @load="onLoad">
        <div v-if="list.length === 0 && !loading" class="empty-list">
          <van-icon name="document-text" size="48" color="#c0c4cc" />
          <p class="empty-text">暂无用户数据</p>
        </div>
        <div class="listItem user-card" v-for="(li, i) in list" :key="i">
          <div class="body">
            <div class="person-header">
              <div class="avatar">
                <img :src="li.avatar || '/default-avatar.png'" alt=""></div>
              <div class="left">
                <div class="name">{{ li.userInfo.nickName }}</div>
                <div class="uid" @click="onUidTapped(li)">ID: {{ li.userId }}</div>
                <div class="uid">加入时间: {{ !!li.joinTime ? getDisplayTime(li.joinTime) : '--' }}</div>
              </div>
            </div>

            <div class="data-grid">
              <div class="d-item-inline data-item highlight" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.income) }}</div>
              <div class="t-desc">总收益</div>
              </div>
              <div class="d-item-inline data-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%"
                   @click="onInviteCodeTapped(li)">
                <div class="t-time">{{ (!!li.code ? li.code : '--') }}</div>
                <div class="t-desc">邀请码</div>
              </div>
              <div class="d-item-inline data-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%"
                   @click="onParentIdTapped(li)">
                <div class="t-time">{{ (!!li.parentId ? li.parentId : '--') }}</div>
                <div class="t-desc">上级ID</div>
              </div>
            </div>
            <div class="income-details">
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.my) }}</div>
                <div class="t-desc desc">私聊收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.voice) }}</div>
                <div class="t-desc desc">音频收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.video) }}</div>
                <div class="t-desc">视频收益</div>
              </div>
            </div>
            <div class="income-details">
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.gift) }}</div>
                <div class="t-desc">礼物收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.heart) }}</div>
                <div class="t-desc">心动收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (!!li.itemNum ? li.itemNum : '0') }}</div>
                <div class="t-desc">邀请充值分成</div>
              </div>
            </div>
            <div class="stats-section">
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.heartbeatNum ? li.heartbeatNum : '0') }}/{{ (!!li.heartNumRecv ? li.heartNumRecv : '0') }}
                </div>
                <div class="t-desc">心动发送/接收(次)</div>
              </div>
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.voiceCount ? li.voiceCount : '0') }}/{{ (!!li.voiceTime ? li.voiceTime : '0') }}
                </div>
                <div class="t-desc">语音通话(次/分钟)</div>
              </div>
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.videoCount ? li.videoCount : '0') }}/{{ (!!li.videoTime ? li.videoTime : '0') }}
                </div>
                <div class="t-desc">视频通话(次/分钟)</div>
              </div>
            </div>
          </div>
          <div class="foot">
            <div class="left lines_right action-button" @click="onCopyUserIdTapped(li)">
              <van-icon name="copy" size="14" color="#409EFF" />
              <span>复制用户ID</span>
            </div>
            <div class="right action-button" @click="onIncomeTapped(li)">
              <van-icon name="list" size="14" color="#67C23A" />
              <span>查看流水</span>
            </div>
          </div>
        </div>
      </van-list>
      <van-popup v-model:show="showDatePicker" position="bottom" round>
        <van-datetime-picker v-model="datePicker" type="date" title="选择日期" :min-date="minDate" :max-date="maxDate"
                             @confirm="onDatePickerConfirm" @cancel="onDatePickerCancel"/>
      </van-popup>
    </div>
    <div v-if="!!groupInfo" class="bottom">
       <div v-if="incomeList && incomeList.length === 0" class="empty-state">
      <span>暂无相关流水数据</span>
    </div>
    
    <!-- 表格数据 -->
    <table v-else style="border-collapse: collapse;border-radius: 20px 20px 0 0;
 width: 100%; margin-top: 10px; background-color: #1a1a1a; color: #ffffff;">
      <!-- 收益流水 - type=0 -->
      <tr style="background-color: #2a2a2a;">
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">收益流水</div>
           <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(0).totalIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">邀请分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(0).totalParentIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">组长分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(0).totalOwnerIncome) }}</div>
        </td>
      </tr>
      
      <!-- 充值流水 - type=1 -->
      <tr v-if="formatNumber(getIncomeByType(1).totalOwnerIncome)!='0'" style="background-color: #2a2a2a;">
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">充值流水</div>
           <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(1).totalIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">邀请分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(1).totalParentIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">组长分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(1).totalOwnerIncome) }}</div>
        </td>
      </tr>
      
      <!-- 会员流水 - type=2 -->
      <tr v-if="formatNumber(getIncomeByType(2).totalOwnerIncome)!='0'" style="background-color: #2a2a2a;">
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">会员流水</div>
              <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(2).totalIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">邀请分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(2).totalParentIncome) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="color: #ffffff;">组长分成</div>
          <div style="color: #ffffff;">{{ formatNumber(getIncomeByType(2).totalOwnerIncome) }}</div>
        </td>
      </tr>

      <tr style="background-color: #3a3a3a;">
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">总流水</div>
          <div style="font-weight: bold; color: #ffffff;">{{ formatNumber( calculateGrandTotal()) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">邀请分成合计</div>
          <div style="font-weight: bold; color: #ffffff;">{{ formatNumber(calculateTotalParentIncome()) }}</div>
        </td>
        <td style="padding: 8px; border: none; color: #ffffff;">
          <div style="font-weight: bold; color: #ffffff;">组长分成合计</div>
          <div style="font-weight: bold; color: #ffffff;">{{ formatNumber(calculateTotalOwnerIncome()) }}</div>
        </td>
      </tr>

    </table>
      <!-- <div class="part">
        <div class="value">{{ totalIncome }}</div>
        <div class="key">{{ this.groupInfo ? (this.groupInfo.type === 0 ? '总收益' : '总充值') : '' }}</div>
      </div>
      <div class="part">
        <div class="value">{{ totalUserChatIncome }}</div>
        <div class="key">用户聊天收益</div>
      </div>
      <div class="part">
        <div class="value">{{ userInviteRewards }}</div>
        <div class="key">用户邀请收益</div>
      </div>
      <div class="part">
        <div class="value">{{ totalParentIncome }}</div>
        <div class="key">邀请分成</div>
      </div>
      <div class="part">
        <div class="value">{{ groupChatRewards }}</div>
        <div class="key">组长聊天分成</div>
      </div>
      <div class="part">
        <div class="value">{{ groupInviteRewards }}</div>
        <div class="key">组长邀请分成</div>
      </div> -->
    </div>
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import {Toast} from "vant"
import moment from 'moment'
import copy from "copy-to-clipboard";


export default {
  name: 'Income',
  data() {
    return {
      show: true,
      search: '',
      downloadUrl: '',
      checked: '0',
      incomeType: 0,
      incomeTypes: [
        {text: '全部类型', value: 0},
        {text: '私聊送礼', value: 22},
        {text: '心动送礼', value: 63},
        {text: '普通聊天', value: 52},
        {text: '语音', value: 37},
        {text: '视频', value: 55},
        {text: '邀请充值分成', value: 66},
         { text: '邀请开通会员分成', value: 74 },
      ],
      timeBegin: 0,
      timeEnd: 0,
      showDatePicker: false,
      datePickerMode: 0,
      datePicker: null,
      minDate: null,
      maxDate: null,
      groupInfo: null,
      searchUid: null,
      searchType: 0,
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      incomeList:[],
      totalIncome: 0,
      totalUserChatIncome: 0,
      userInviteRewards: 0,
      totalParentIncome: 0,
      groupChatRewards: 0,
      groupInviteRewards: 0,
      marke: false,
      isDownloaded: false // 是否已下载标志
      , params: ""
    }
  },
  components: {
    Mask,
  },
  computed: {
    timeBeginDisplay() {
      const date = new Date(this.timeBegin);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    },
    timeEndDisplay() {
      const date = new Date(this.timeEnd);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    }
  },
  mounted() {
    if (this.$route.params.userId) {
      this.search = this.$route.params.userId
      this.searchUid = parseInt(this.search);
    }
    this.reqInfo()
    // this.marke = wxqq()
  },
  methods: {
    /**
     * 根据类型获取对应的收益数据
     * @param {Number} type 流水类型：0收益流水 1充值流水 2会员流水
     * @returns {Object} 对应类型的收益数据对象
     */
    getIncomeByType(type) {
      // 验证输入类型
      if (typeof type !== 'number' || type < 0 || type > 2) {
        console.warn(`无效的流水类型: ${type}`);
        return {};
      }
      
      return this.incomeList.find(item => item.type === type) || {};
    },
       formatNumber(num) {
      // 处理空值或无效值
      if (num === undefined || num === null) {
        return '0';
      }
      
      // 转换为数字
      const number = Number(num);
      if (isNaN(number)) {
        return '0';
      }
      
      // 格式化数字，保留两位小数并添加千分位
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
      /**
     * 计算全部总收益
     * @returns {Number} 所有流水类型的总收益合计
     */
    calculateGrandTotal() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    /**
     * 计算邀请分成总和
     * @returns {Number} 所有类型的邀请分成总和
     */
    calculateTotalParentIncome() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalParentIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    
    /**
     * 计算组长分成总和
     * @returns {Number} 所有类型的组长分成总和
     */
    calculateTotalOwnerIncome() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalOwnerIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    prepareDownload() {
      const requestData = {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      };

      this.params = new URLSearchParams(requestData).toString();


      // 阻止默认跳转行为

      // 在这里编写准备下载的逻辑
      // 例如：从后端获取文件下载链接等
      const downloadUrl = 'http://localhost:8088/manage/stat/user/gincomelistout/x.xls?' + this.params; // 替换为实际的下载链接
      this.downloadUrl = downloadUrl;

      this.$refs.downloadLink.click(); // 模拟用户点击下载链接


    },
    prepareDownload1() {
      const requestData = {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      };

      this.params = new URLSearchParams(requestData).toString();


      // 阻止默认跳转行为

      // 在这里编写准备下载的逻辑
      // 例如：从后端获取文件下载链接等
      const downloadUrl = 'http://localhost:8088/manage/stat/user/gincomelistout/x.xls?' + this.params; // 替换为实际的下载链接
      this.downloadUrl = downloadUrl;


    },

    onUidTapped(li) {
      copy(li.userId);
      Toast('用户ID已复制');
    },
    onInviteCodeTapped(li) {
      copy(li.code);
      Toast('邀请码已复制');
    },
    onParentIdTapped(li) {
      if (!li.parentId) {
        return
      }
      copy(li.parentId);
      Toast('上级ID已复制');
    },
    onCopyUserIdTapped(li) {
      this.onUidTapped(li)
    },
    onIncomeTapped(li) {
      this.$router.push({
        name: 'Income',
        params: {
          userId: li.userId
        }
      });
    },

    downloadFile() {
      this.$request.postJson(this.$mUrl + '/manage/stat/user/gincomelistout', {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      })
          .then(buffer => {
            const encoder = new TextEncoder();
            const xmlData = encoder.encode(buffer.data);
            const blob = new Blob([xmlData], {type: 'application/octet-stream'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let now = new Date();
            let month = now.getMonth() + 1;
            let t = '' + month
            t += now.getDate()
            t += now.getHours()
            let name = '成员收益流水概览' + t + '.xls'
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
          });

    }

    ,

    reqInfo() {
      this.$request.postJson('/api/user/pay_group/info', {})
          .then((res) => {
            if (res.data.code == 0) {
              this.groupInfo = res.data.data;
              if (!this.groupInfo) {
                Toast('暂无推广组信息');
                routerUtil.back()
                return;
              }
              this.prepareDownload1()
              switch (this.groupInfo.period) {
                case 1:
                  this.timeBegin = moment().startOf('day').valueOf();
                  this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                  break;
                case 2:
                  moment
                  this.timeBegin = moment().startOf('day').valueOf();
                  this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                  break;
                case 3:
                  this.timeBegin = moment().startOf('day').valueOf();
                  this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                  break;
              }
              this.getList()
              this.getStatistics()
            }
          })
    },
    getList(type) {
      let lastId = ''
      if (type && this.list.length > 0) {
        lastId = this.list[this.list.length - 1].id
      }
      this.$request.postJson(this.$mUrl + '/manage/stat/user/gincomelist', {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
        lastId: lastId,
        pageSize: 15
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.length == 0) {
            this.loading = false;
            this.refreshing = false
            this.finished = true;
            return
          }
          const uids = [];
          for (let log of res.data.data) {
            uids.push(log.userId);
          }
          this.$request.post('/api/user/info/userInfoByGroup', {userIds: JSON.stringify(uids)})
              .then((res1) => {
                this.loading = false;
                this.refreshing = false
                if (res1.data.code == 0) {
                  console.log(res1.data)
                  const userMap = new Map();
                  for (let user of res1.data.data.users) {
                    if (user.code == 0) {
                      userMap.set(user.userId, user);
                    } else {
                      Toast("请求用户基本信息失败")
                      return;
                    }
                  }
                  for (let log of res.data.data) {
                    log.userInfo = userMap.get(log.userId);
                  }
                  this.list.push(...res.data.data)
                  this.finished = res.data.data.length < 15
                }
              })
        }
      })
    }
    ,
    getStatistics() {
      this.$request.postJson(this.$mUrl + '/manage/stat/user/getIncomeTotalList', {
        groupId: this.groupInfo.id,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
         ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
      }).then((res) => {
        if (res.data.code == 0) {
          console.log(res.data.data);
          this.incomeList = res.data.data;
           this.incomeList.forEach(item => { 
            if(item.type==1&& item.totalOwnerIncome==0)
          {
            

this.incomeTypes.forEach((item,index)=>{
if(item.value==66)
{
  this.incomeTypes.splice(index, 1);
}
})



            
          }
                if(item.type==2&& item.totalOwnerIncome==0)
          {
            
          
this.incomeTypes.forEach((item,index)=>{
if(item.value==74)
{
  this.incomeTypes.splice(index, 1);
}
})





            
          }
          });
          // this.totalIncome = res.data.data[0].totalIncome;
          // this.totalUserChatIncome = res.data.data[0].totalUserChatIncome;
          // this.userInviteRewards = res.data.data[0].userInviteRewards;
          // this.totalParentIncome = res.data.data[0].totalParentIncome;
          // this.groupChatRewards = res.data.data[0].groupChatRewards;
          // this.groupInviteRewards = res.data.data[0].groupInviteRewards;
        }
      })
    }
    ,
    onClickLeft() {
      routerUtil.back()
    }
    ,
    onClickRight() {
    }
    ,
    onSearch() {
      if (this.search == "") {
        this.searchUid = null
      } else {
        if (isNaN(Number(this.search, 10))) {
          Toast("请输入用户ID")
          return
        }
        const uid = parseInt(this.search);
        this.searchUid = uid;
      }
      this.searchType = parseInt(this.checked)
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    }
    ,
    onIncomeTypeChanged() {
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    }
    ,
    onTimeBeginTapped() {
  this.datePickerMode = 1;
  this.datePicker = new Date(this.timeBegin || Date.now());
  
  // 核心：开始时间最早为「当前时间-1个月」，最晚为当前时间
  const oneMonthAgo = moment().subtract(1, 'month').toDate(); // 一个月前
  this.minDate = oneMonthAgo;
  this.maxDate = new Date(); // 当前时间
  
  // UI上只显示最近一个月的日期，超出部分置灰
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
  this.showDatePicker = true;
},

// 点击结束时间选择器
onTimeEndTapped() {
  if (!this.timeBegin) {
    alert('请先选择开始时间');
    return;
  }
  
  this.datePickerMode = 2;
  this.datePicker = new Date(this.timeEnd || this.timeBegin);
  
  // 计算两个上限：开始时间+1个月 和 当天
  const oneMonthLater = moment(this.timeBegin).add(1, 'month').toDate();
  const today = new Date(); // 当天（默认00:00:00，如需包含当天所有时间可改为endOf('day')）
  
  // 结束时间最大可选值为：两者中的较小值（不超过当天，且不超过开始时间+1个月）
  this.minDate = new Date(this.timeBegin);
  this.maxDate = oneMonthLater > today ? today : oneMonthLater;
   this.showDatePicker = true;
  // 禁用超出范围的日期（小于开始时间 或 大于最大限制）
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
 
},

// 确认选择
onDatePickerConfirm(value) {
  switch (this.datePickerMode) {
    case 1:
      // 开始时间已被UI限制在最近一个月内，直接取值
      this.timeBegin = moment(value).startOf('day').valueOf();
      
      // 如果结束时间未设置或结束时间早于开始时间，则设置结束时间为开始时间
      if (!this.timeEnd || this.timeEnd < this.timeBegin) {
        this.timeEnd = moment(this.timeBegin).endOf('day').valueOf();
      }
      break;
      
    case 2: {
      // 结束时间限制在开始时间+1个月内
      this.timeEnd = moment(value).endOf('day').valueOf();
 
      // 确保结束时间不早于开始时间
      if (this.timeEnd < this.timeBegin) {
        this.timeEnd = moment(this.timeBegin).endOf('day').valueOf();
      }
      
      // 确保结束时间不超过开始时间+1个月
      const maxEndTime = moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
      if (this.timeEnd > maxEndTime) {
        this.timeEnd = maxEndTime;
      }
      break;
    }
  }
  
  this.showDatePicker = false;
  this.datePickerMode = 0;
  this.list = [];
  this.onRefresh();
  this.getStatistics();
}
    ,
    onDatePickerCancel() {
      this.datePickerMode = 0;
      this.showDatePicker = false;
    }
    ,
    onLoad() {
      this.getList(true)
    }
    ,
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getList()
    }
    ,
    getDisplayTime(time) {
      const date = new Date(time);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const min = date.getMinutes();
      const sec = date.getSeconds();
      return `${date.getFullYear()}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
    }
  },
}
</script>
<style scoped lang="less">
// 全局样式
.box {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  font-size: 14px;
  color: #ffffff;
  padding-bottom: 200px;
}

// 导出按钮
.export-button {
  color: #ffffff !important;
  border-color: #666666 !important;
  height: 30px;
  padding: 0 12px;
  font-size: 12px;
  border-radius: 15px;
  margin-right: 8px;
  background-color: transparent !important; // 确保背景透明
}

.export-button.van-button--plain {
  color: #ffffff !important;
  border-color: #666666 !important;
}

.export-button.van-button--plain:active {
  background-color: rgba(102, 102, 102, 0.2) !important;
}

// 搜索区域
.search-section {
  background: #2a2a2a;
  border-radius: 12px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border: 1px solid #3a3a3a;
}

// 搜索框 - 终极强制覆盖（优先级拉满）
.search {
  margin-bottom: 12px;
  // 强制穿透所有层级，优先级最高
  :deep(.van-search) {
    --van-search-background-color: #3a3a3a !important; // 干掉白色背景变量
    --van-search-content-background-color: #3a3a3a !important; // 输入框背景变量
    --van-search-field-color: #ffffff !important; // 输入文字颜色变量
    --van-search-placeholder-color: #909090 !important; // 占位符颜色变量
    
    background: transparent !important; // 兜底：直接覆盖background
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: var(--van-search-padding);
    
    &::after {
      display: none !important; // 干掉下划线
    }
  }
  
  :deep(.van-search__content) {
    background: #3a3a3a !important; // 搜索框背景（深色）
    border-radius: 20px !important;
    border: none !important;
  }
  
  :deep(.van-search__field) {
    background: #3a3a3a !important; // 输入框背景
    font-size: 14px !important;
    color: #ffffff !important; // 输入文字颜色
    caret-color: #ffffff !important; // 光标颜色
  }
  
  // 占位符样式（兼容所有浏览器）
  :deep(.van-search__field::placeholder) {
    color: #909090 !important;
  }
  :deep(.van-search__field::-webkit-input-placeholder) {
    color: #909090 !important;
  }
  :deep(.van-search__field:-moz-placeholder) {
    color: #909090 !important;
  }
  
  // 搜索按钮（绝对不被覆盖）
  :deep(.van-search__action) {
    color: #ffffff !important; // 按钮文字颜色
    font-weight: 500 !important;
    font-size: 14px !important;
    padding: 0 12px !important;
  }
}

// 手动写的搜索按钮（兜底）
.search-action {
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  padding: 0 12px !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

// Radio组件样式
:deep(.van-radio-group) {
  color: #ffffff !important;
  
  .van-radio {
    color: #ffffff !important;
    
    .van-radio__label {
      color: #ffffff !important;
      font-size: 14px;
    }
  }
  
  .van-radio--checked {
    .van-radio__icon {
      background-color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-radio__label {
      color: #ffffff !important;
      font-weight: 500;
    }
  }
}

.income-type {
  width: 120px;
  
  :deep(.van-dropdown-menu__bar) {
    background: transparent;
    box-shadow: none;
    
    .van-dropdown-menu__title {
      font-size: 13px;
      color: #ffffff;
    }
    
    .van-dropdown-menu__arrow {
      color: #888888;
    }
  }
}

// 日期范围选择
.date-range {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #e0e0e0;
}

.date-range .time {
  display: flex;
  align-items: center;
  background: #3a3a3a;
  padding: 6px 12px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #4a4a4a;
  
  &:hover {
    background: #4a4a4a;
    border-color: #5a5a5a;
  }
  
  :deep(.van-icon) {
    color: #ffffff !important;
  }
}

// 空列表状态
.empty-list {
  text-align: center;
  padding: 40px 0;
  
  .empty-text {
    margin-top: 12px;
    color: #666666;
    font-size: 14px;
  }
  
  :deep(.van-icon) {
    color: #4a4a4a !important;
  }
}

// 用户卡片
.user-card {
  border-radius: 12px;
  margin: 0 16px 16px 16px;
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid #3a3a3a;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
    border-color: #4a4a4a;
  }
  
  .body {
    padding: 16px;
  }
}

// 用户头像
.avatar {
  width: 50px;
  height: 50px;
  display: inline-block;
  
  img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 2px solid #e8f5e9;
  }
}

// 个人信息
.person-header {
  margin-left: 0;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.person-header .left {
  padding-left: 12px;
  
  .name {
    font-size: 16px;
    font-weight: 500;
    color: #4CAF50;
    margin-bottom: 4px;
  }
  
  .uid {
    font-size: 12px;
    color: #81c784;
    margin-bottom: 2px;
    
    &:not(:last-child) {
      color: #4CAF50;
      cursor: pointer;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// 数据网格样式
.data-grid,
.income-details,
.stats-section {
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.detail-item {
  border-radius: 6px;
  background: #e8f5e9;
  
  .t-time {
    color: #4CAF50;
  }
}

.detail-item {
  border-radius: 6px;
  background: #fff8f0;
  
  .t-time {
    color: #ff9500;
  }
}

.stats-item {
  
  .t-time {
    font-size: 12px;
  }
  
  .t-desc {
    font-size: 10px;
    line-height: 1.2;
  }
}

// 操作按钮
.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  
  &.left {
    color: #4CAF50;
  }
  
  &.right {
    color: #388e3c;
  }
  
  &:hover {
    background: rgba(76, 175, 80, 0.05);
  }
}

// 底部统计区域
.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  
  border-radius: 20px 20px 0 0;
  padding: 16px;
  box-shadow: 0 -2px 10px rgba(76, 175, 80, 0.1);

}

.empty-state {
  text-align: center;
  padding: 20px 0;
  color: #81c784;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
}

// 统计卡片
.stats-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-card {
  background: #f1f8e9;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e8f5e9;
  
  &.total-card {
    background: #e8f5e9;
    border-left: 3px solid #4CAF50;
  }
}

.stat-header {
  margin-bottom: 8px;
}

.stat-header h4 {
  font-size: 14px;
  font-weight: 500;
  color: #4CAF50;
  margin: 0 0 4px 0;
}

.stat-amount {
  font-size: 16px;
  font-weight: bold;
  color: #4CAF50;
  
  &.total {
    font-size: 18px;
    color: #388e3c;
  }
}
// 自定义搜索框样式（100%可控，无任何Vant变量干扰）
.custom-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  width: 100%;
  
  // 输入框容器（模拟round形状）
  .search-input-wrap {
    flex: 1;
    background: #3a3a3a;
    border-radius: 20px; // 对应原来的shape="round"
    padding: 8px 16px;
    box-sizing: border-box;
  }
  
  // 输入框
  .search-input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    color: #ffffff; // 输入文字颜色
    font-size: 14px;
    
    // 占位符样式（全浏览器兼容）
    &::placeholder {
      color: #909090;
      font-size: 14px;
    }
    &::-webkit-input-placeholder {
      color: #909090;
    }
    &:-moz-placeholder {
      color: #909090;
    }
  }
  
  // 搜索按钮
  .search-action-btn {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;
    white-space: nowrap;
  }
}
.stat-details {
  display: flex;
  justify-content: space-between;
}

.stat-details .detail-item {
  background: transparent;
  padding: 0;
  flex: 1;
  
  .label {
    font-size: 12px;
    color: #81c784;
    display: block;
    margin-bottom: 2px;
  }
  
  .value {
    font-size: 14px;
    font-weight: 500;
    color: #4caf50;
  }
}

// 导航栏样式
:deep(.van-nav-bar) {
  background: #1a1a1a !important; // 确保导航栏背景为深色
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  &__title {
    color: #fff;
    font-weight: 500;
  }
  
  &__left {
    color: #fff;
    
    .van-icon {
      color: #fff !important;
    }
  }
}

// 列表样式覆盖
:deep(.van-list) {
  padding: 0;
  
  &__loading,
  &__finished-text {
    color: #81c784;
    font-size: 13px;
    padding: 16px 0;
  }
}

// 下拉菜单样式
:deep(.van-dropdown-menu) {
  :deep(.van-dropdown-menu__content) {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.15);
  }
  
  :deep(.van-dropdown-item) {
    font-size: 14px;
    color: #4caf50;
    
    &.van-dropdown-item--active {
      color: #4CAF50;
      font-weight: 500;
    }
  }
}

// 弹窗样式
:deep(.van-popup) {
  :deep(.van-popup__close-icon) {
    color: #909399;
  }
}

:deep(.van-datetime-picker) {
  :deep(.van-picker__toolbar) {
    background: #ffffff;
    
    .van-picker__title {
      font-weight: 500;
      color: #4CAF50;
    }
  }
  
  :deep(.van-picker__confirm) {
    color: #4CAF50;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .box {
    padding-bottom: 220px;
  }
  
  .search-section {
    margin: 12px;
    padding: 14px;
  }
  
  .search-filters {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .income-type {
    width: 100%;
  }
  
  .user-card {
    margin: 0 12px 12px 12px;
    
    .body {
      padding: 14px;
    }
  }
  
  .bottom {
    padding: 14px;
  }
  
  .stat-card {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .person-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .avatar {
    margin-bottom: 8px;
  }
  
  .stat-details {
    flex-direction: column;
    gap: 8px;
  }
}

// 原有样式调整
.t-desc {
  color: #4caf50;
}

.list {
  position: relative;
  width: 100%;
  background-color: transparent;
}

.list .listItem {
  margin-top: 0;
}

.foot {
  position: relative;
  width: 100%;
  height: 48px;
  font-size: 14px;
  line-height: 48px;
  border-top: 1px solid #f0f0f0;
  
  .left,
  .right {
    display: inline-block;
    width: calc(100% / 2);
    text-align: center;
  }
}

.van-pull-refresh {
  height: 100% !important;
  overflow: auto !important;
}

.van-list {
  height: auto !important;
}
</style>
